export interface IPhoneLink {
  label: string
  tel: string
}

export const usePhone = () => {
  const formatPhoneForTel = (phone: string) => {
    return phone.replace(/\s+/g, '')
  }

  /**
   * Splits a field with several numbers ("+996 707 86 96 88, +996 778 86 96 88"
   * or the older "0707869688; 0778869688") into one link per number.
   */
  const splitPhones = (value?: string | null): IPhoneLink[] => {
    return (value || '')
      .split(/[;,\n]/)
      .map((phone) => phone.trim())
      .filter(Boolean)
      .map((phone) => ({ label: phone, tel: phone.replace(/[^\d+]/g, '') }))
  }

  return {
    formatPhoneForTel,
    splitPhones
  }
}
